import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import {
  ActionsEnum,
  FetchOffer,
  setOffer,
  SetOffer,
} from './pricing-data.actions';
import { catchError, flatMap, map } from 'rxjs/operators';
import { PricingDataService } from './pricing-data.service';
import { IResponseInfo } from '../http/http.data';
import { PricingOffer } from './models/pricing-offer.model';

@Injectable()
export class PricingDataEffects {
  constructor(
    private _actions: Actions,
    private _pricingDataService: PricingDataService
  ) {}

  @Effect()
  fetchOffer: Observable<SetOffer> = this._actions.pipe(
    ofType(ActionsEnum.FETCH_OFFER),
    flatMap(({ payload }: FetchOffer) => {
      const { offerType } = payload;

      return this._pricingDataService.fetchOffer(offerType).pipe(
        map(({ body }: IResponseInfo) =>
          setOffer(
            offerType,
            body['offer'] ? new PricingOffer(body['offer']) : false
          )
        ),
        catchError(() => of(setOffer(offerType, false)))
      );
    })
  );
}
